import api from "./api";

export const authService = {
  login: async (email, password) => {
    const response = await api.post("/api/auth/login", { email, password });
    return response.data;
  },

  forgotPassword: async (email) => {
    const response = await api.post("/api/auth/forgot-password", { email });
    return response.data;
  },

  resetPassword: async (token, newPassword) => {
    const response = await api.post("/api/auth/reset-password", {
      token,
      newPassword,
    });
    return response.data;
  },

  changePassword: async (currentPassword, newPassword) => {
    const response = await api.patch("/api/auth/change-password", {
      currentPassword,
      newPassword,
    });
    return response.data;
  },

  updateProfile: async (name, email) => {
    const response = await api.patch("/api/auth/profile", { name, email });
    return response.data;
  },

  getProfile: async () => {
    const response = await api.get("/api/auth/profile");
    return response.data;
  },
};
